<template>
  <el-dialog :visible.sync="dialogVisible" custom-class="detail_dialog" :top="'5vh'" :fullscreen="isExpand"
    :show-close="false" :before-close="handleClose" width="1200px">
    <template slot="title">
      <div class="default-dialog-title-box">
        <span>查看</span>
        <span class="icon-box">
          <img :src="!isExpand ? expandSvg : collapseSvg" @click="isExpand = !isExpand">
          <i class="el-icon-close" @click="handleClose"></i>
        </span>
      </div>
    </template>
    <div class="content">
      <PushTenantList :tenantId="tenantId" />
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">关闭</el-button>
    </span>
  </el-dialog>
</template>
<script>
import PushTenantList from './pushTenantList.vue';

export default {
  components: {
    PushTenantList,
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    tenantId: {
      type: [Number, String],
      default: '',
    },
  },
  data () {
    return {
      isExpand: false,
      expandSvg: require('@/assets/ic_expand.svg'), // eslint-disable-line
      collapseSvg: require('@/assets/ic_collapse.svg'), // eslint-disable-line
    };
  },
  methods: {
    handleClose () {
      this.$emit('update:dialogVisible', false);
    },
  },
};
</script>

<style scoped lang="scss">
.detail_dialog {
  /deep/ .el-dialog__header {
    padding: 16px 20px;
  }
}
</style>
